// https://ik.imgkit.net/ikmedia/logo/dark_t8FRfVBou.svg
// https://ik.imgkit.net/ikmedia/logo/light_T4buIzohVH.svg

const globalStyleVariables = {
  infraImage:
    "https://ik.imgkit.net/ikmedia/site_graphics/Globally_distributed_image_processing_network_3_2x_3o79hHeyU.png",
  logoUrl: "https://ik.imgkit.net/ikmedia/logo/light_T4buIzohVH.svg",
  whiteLogoUrl:
    "https://ik.imagekit.io/ikmedia/logo/ikLogoWhite_30FbZCVusC.svg",
  gdprReadyBadge: "https://ik.imagekit.io/ikmedia/website-assets/badges/gdpr_ready_eVyJexl_y.png?tr=w-120",
  isoComplianceBadge: "https://ik.imagekit.io/ikmedia/website-assets/badges/iso-27001-badge_-pxQ1X8IL.png?tr=w-120",
  LIGHT_BG: "#FAFAFA",
  CARD_SHADOW: "rgba(4, 80, 213, 0.1) 0px 8px 20px 0px",
  MEDIUM_BG: "#F5F9FD",
  INLINE_CODE_BG: "#e5eff5",
  LOGO_BLUE: "#0450d5",
  DARK_BG: "#011a45",
  LINK_COLOR: "#0450d5",
  TEXT_PRIMARY: "#1a202c",
  TEXT_SECONDARY: "#4a5568",
  BLUE_INACTIVE: "rgba(11, 27, 54, 0.8)",
  BLUE_PLACEHOLDER: "rgba(11, 27, 54, 0.6)",
  BLUE_DISABLED: "rgba(11, 27, 54, 0.4)",
  BLUE_OFF_WHITE: "#f3f8ff",
  WHITE_ACTIVE: "#ffffff",
  WHITE_PLACEHOLDER: "rgba(255, 255, 255, 0.6)",
  WHITE_DISABLED: "rgba(255, 255, 255, 0.4)",
  BRAND_RED: "#f55069",
  BRAND_RED_PLACEHOLDER: "rgba(245, 80, 105, 0.2)",
  BRAND_BLUE: "#0450d5",
  BRAND_LIGHT_BLUE: "#2c93fa",
  BRAND_YELLOW: "#fdb400",
  ACCENT_BLUE: "#eaf4fe",
  BLACK_DIVIDER: "#e0e4ec",
  WHITE_DIVIDER: "rgba(255, 255, 255, 0.2)",
  MOBILE_MEDIA_QUERY: "(max-width: 1024px)",
  MOBILE_MEDIA_QUERY_CHAKRA: '(max-width: 1024px)',
  DESKTOP_MEDIA_QUERY: "min-width: 1025px",
  CONTAINER_MAX_WIDTH: "1080px",
  BUTTON_BORDER_RADIUS: "40px",
  RED_SHADE: "#ed516e",
  IMAGEKIT_GRAY_500: "#a0aec0",
  desktop: {
    CONTAINER_WIDTH: "1080px",
    H1_FONT_SIZE: "48px",
    H1_LINE_HEIGHT: "1.4",
    H1_LETTER_SPACING: "-1.28px",
    H2_FONT_SIZE: "32px",
    H2_LINE_HEIGHT: "1.5",
    H2_LETTER_SPACING: "-0.44px",
    H3_FONT_SIZE: "20px",
    H3_LINE_HEIGHT: "1.5",
    H3_LETTER_SPACING: "normal",
    SLAB_TOP_BOTTOM_PADDING: "70px",
  },
  mobile: {
    CONTAINER_WIDTH: "100vw",
    H1_FONT_SIZE: "28px",
    H1_LINE_HEIGHT: "1.5",
    H1_LETTER_SPACING: "-0.72px",
    H2_FONT_SIZE: "20px",
    H2_LINE_HEIGHT: "1.36",
    H2_LETTER_SPACING: "-0.44px",
    H3_FONT_SIZE: "20px",
    H3_LINE_HEIGHT: "26.6px",
    H3_LETTER_SPACING: "0px",
    SLAB_TOP_BOTTOM_PADDING: "40px",
  },
}

export { globalStyleVariables }
